// Client configuration.
//
// In production the React app is served from the same Catalyst domain as the
// function, so a relative base URL works and the request is authenticated by
// the user's Catalyst session (no key in the browser).
//
// In development, point REACT_APP_OCR_API_URL at the deployed/served function
// and supply REACT_APP_OCR_API_KEY (in a gitignored .env.local).
// NOTE: shipping the API key in a production bundle is insecure — prefer the
// Catalyst-session path for production.

const DEFAULT_BASE = '/server/ai_ocr_reader_function';

export const API_BASE_URL = (
  process.env.REACT_APP_OCR_API_URL || DEFAULT_BASE
).replace(/\/$/, '');

export const API_KEY = process.env.REACT_APP_OCR_API_KEY || '';

// Keep in sync with the server's MAX_FILE_SIZE_MB for friendly client-side
// validation (the server remains the source of truth).
export const MAX_FILE_SIZE_MB = Number(process.env.REACT_APP_MAX_FILE_SIZE_MB || 15);

export const ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/heic',
  'image/heif',
  'image/gif',
  'image/tiff',
  'image/bmp',
];
